import {css} from 'lit';
import {tablet} from '../../js/services/const';

export default css`
::selection {
  background: var(--brand);
  color: var(--brand-text);
}

:host {
  --gap: 1.6rem;
  --facebook: #3b5998;
}

ul {
  padding: 0;
}

.quiz__wrapper {
  padding-bottom: 0.8rem;
}

.quiz__content>p {
  font-size: 1.6rem;
  line-height: 2.6rem;
}

.quiz__featured-image.active {
  transition: all 0.1s ease-in 0.1s;
  opacity: 1;
}

.quiz__featured-image.inactive {
  transition: none;
  opacity: 0;
}

.quiz__featured-image img {
  width: 100%;
  height: auto;
}

.quiz__featured-image .copyright {
  display: block;
  line-height: 1.6rem;
  color: var(--cp-grey-light-3);
  font-size: 1.2rem;
  text-align: right;
}

.quiz__featured-image .copyright::before {
  content: '\\00a9';
  margin-right: 5px;
}

.quiz__featured-image .copyright::first-letter {
  font-size: 10px;
}

.quiz__label-wrapper {
  border-bottom: 0.1rem solid #ccc;
  text-align: center;
  margin: 0 0 3.6rem 0;
}

.quiz__label-wrapper .block-label {
  position: relative;
  display: inline-block;
  top: 1.6rem;
  line-height: 3.2rem;
  padding: 0 1rem;
  background-color: var(--white);
  color: var(--cp-grey-light-3);
  font-size: 2rem;
  font-family: var(--font-family-sans-serif);
  font-style: italic;
  font-weight: 700;
  white-space: nowrap;
}

.quiz__label-wrapper .block-label .question {
  color: var(--text-highVisibility);
}

.quiz__label-wrapper .block-label .question.allAnswered {
  font-weight: 700;
}

.quiz__label-wrapper .block-label .current-page {
  font-size: 2rem;
  line-height: 2rem;
  color: var(--text-highVisibility);
}

@media (min-width: ${tablet}px) {
  .quiz__label-wrapper .block-label .current-page {
    font-size: 2.4rem;
    line-height: 2.4rem;
  }
}

.currentQuestion {
  margin: 2.4rem 0 1.6rem 0;
  line-height: 2.8rem;
  font-weight: 700;
  font-size: 2.4rem;
}

.quizQuestions {
  width: 100%;
  display: block;
}

.quizQuestions.active {
  transition: all 0.1s ease-in 0.1s;
  opacity: 1;
}

.quizQuestions.inactive {
  transition: none;
  opacity: 0;
}

.quizQuestions li {
  display: table;
  padding: 0;
  width: 100%;
  margin-bottom: 1.6rem;
  cursor: pointer;
  font-family: var(--font-family-sans-serif);
  font-size: 1.6rem;
  line-height: 2rem;
  border-radius: 0.4rem;
}

.quizQuestions li::before {
  content: none;
  display: none;
}

.quizQuestions li:hover {
  box-shadow: none;
  border-color: rgba(0, 0, 0, 0.3);
  background-color: var(--body-bg);
}

.touchevents .quizQuestions li:hover {
  border: 0;
  background: inherit;
}

.quizQuestions li div {
  display: table-row;
}

.quizQuestions li div span {
  display: table-cell;
}

.quizQuestions li div span:hover {
  cursor: pointer;
}

.quizQuestions li div span.questionNumber {
  padding: 0;
  width: 4rem;
  vertical-align: middle;
  font-weight: 700;
  text-align: center;
  border-top-left-radius: 0.4rem;
  border-bottom-left-radius: 0.4rem;
  color: var(--white);
  background-color: var(--quiz-question-number-bg);
}

.quizQuestions li div span.questionText {
  padding: 2rem;
  border-top-right-radius: 0.4rem;
  border-bottom-right-radius: 0.4rem;
  border: 0.1rem solid #ccc;
  border-left: 0;
  background-color: var(--white);
}

@media (min-width: ${tablet}px) {
  .quizQuestions li div span.questionText:hover {
    background: #f5f5f5;
  }
}

.forceclickmsg {
  display: none;
}

.quizRightQuestions {
  margin: 0;
  padding: 2rem 0 3rem 0;
}

.quizSolutions {
  display: block;
  clear: both;
  border-top: 0.1rem solid #ccc;
}

.quizSolutions li {
  padding: 0.8rem 0 0.8rem 0;
  border-bottom: 0.1rem solid #ccc;
  display: block;
}

.quizSolutions li::before {
  content: '';
  display: none;
}

@media (min-width: ${tablet}px) {
  .quizSolutions li.hasImage {
    min-height: 8.5rem;
  }
}

.quizSolutions li .quizResponse {
  position: relative;
  display: inline-block;
  min-height: 0.8rem;
  margin: 0;
  width: 100%;
  font-size: 1.6rem;
  line-height: 2.4rem;
}

.quizSolutions li .quizResponse li {
  position: relative;
  float: left;
  padding: 0;
  border: 0;
}

.quizSolutions li .quizResponse li.rightOrWrong .icon {
  font-size: 2rem;
  line-height: 2.0rem;
}

@media (min-width: ${tablet}px) {
  .quizSolutions li .quizResponse li.rightOrWrong .icon {
    font-size: 2.4rem;
    line-height: 2.4rem;
  }
}

.quizSolutions li .quizResponse li.rightOrWrong .icon.icon-check {
  color: var(--awareness-consistent);
}

.quizSolutions li .quizResponse li.rightOrWrong .icon.icon-close {
  color: var(--awareness-important);
}

.quizSolutions li .quizResponse li.quizNumber {
  margin-right: 1.4rem;
  color: var(--cp-grey-light-3);
  font-family: var(--font-family-sans-serif);
  font-style: italic;
  font-size: 2rem;
  line-height: 1.9rem;
  letter-spacing: -1px;
  width: 2rem;
}

@media (min-width: ${tablet}px) {
  .quizSolutions li .quizResponse li.quizNumber {
    font-size: 3.2rem;
    line-height: 2.7rem;
    font-weight: normal;
    width: 3.5rem;
  }
}

.quizSolutions li .quizResponse li.quizQuestionAndAnswer {
  position: relative;
  float: none;
  margin: 0;
  padding-left: 7rem;
}

@media (min-width: ${tablet}px) {
  .quizSolutions li .quizResponse li.quizQuestionAndAnswer {
    float: none;
    padding: 0;
    padding-right: 10rem;
    padding-left: 12rem;
  }
}

.quizSolutions li .quizResponse li.quizQuestionAndAnswer .quizQuestion {
  color: var(--black);
  font-family: var(--font-family-sans-serif);
  font-weight: 700;
  line-height: 1.8rem;
}

.quizSolutions li .quizResponse li.quizQuestionAndAnswer .quizWrong,
.quizSolutions li .quizResponse li.quizQuestionAndAnswer .quizRight,
.quizSolutions li .quizResponse li.quizQuestionAndAnswer .quizAnswer {
  font-weight: normal;
  line-height: 1.8rem;
}

.quizSolutions li .quizResponse li.quizQuestionAndAnswer .quizWrong {
  color: var(--awareness-important);
}

.quizSolutions li .quizResponse li.quizQuestionAndAnswer .quizRight {
  color: var(--awareness-consistent);
}

.quizSolutions li .quizResponse li.quizQuestionAndAnswer .quizAnswer {
  color: var(--cp-grey-light-3);
  font-style: italic;
}

.quizSolutions li .quizResponse li.quizThumbnail {
  display: none;
  text-align: center;
}

@media (min-width: ${tablet}px) {
  .quizSolutions li .quizResponse li.quizThumbnail {
    position: absolute;
    display: block;
    top: 0;
    right: 0;
    width: 8.5rem;
    height: 8.5rem;
    overflow: hidden;
  }

  .quizSolutions li .quizResponse li.quizThumbnail img {
    width: auto;
    height: 100%;
    box-shadow: #000 0 0 0;
    margin-left: -100%;
    margin-right: -100%;
  }
}

.quizButtonWrapper {
  clear: both;
  display: flex;
  justify-content: center;
}

.quizButtonWrapper button {
  display: inline-block;
  margin: 0 calc(var(--gap) / 2) var(--gap) calc(var(--gap) / 2);
}

@media (min-width: ${tablet}px) {
  .quizButtonWrapper {
    justify-content: end;
  }

  .quizButtonWrapper button {
    margin: 0 0 var(--gap) 0;
  }

  .quizButtonWrapper button+button {
    margin-left: var(--gap);
  }
}

button.quizFacebook {
  margin: 0 0 2.4rem 0;
  background-color: var(--cp-grey-light-1);
  color: var(--white);
  background-color: var(--facebook);
}

button.quizFacebook .icon-svg-facebook {
  position: relative;
  top: 0;
  margin-right: var(--gap);
  border-radius: 0.2rem;
  width: 2rem;
  height: 2rem;
  line-height: 2rem;
  font-size: 1.4rem;
  background-color: var(--white);
  color: var(--facebook);
}

button.quizFacebook .icon-svg-facebook:before {
  position: relative;
  content: '\\e60a';
}

button.quizFacebook.deactive {
  color: var(--text-lowVisibility);
}

button.quizFacebook.deactive .icon-svg-facebook {
  color: var(--text-lowVisibility);
}

.quizResultPage {
  font-size: 1.2rem;
  line-height: 4.2rem;
  height: 4.2rem;
  color: var(--text-highVisibility);
  text-align: right;
}

.quizResultPage a {
  color: var(--text-highVisibility);
  transition: all 0.1s ease-in 0.1s;
  opacity: 0;
  visibility: hidden;
}

.quizResultPage a.active {
  opacity: 1;
  visibility: visible;
}

.quizResultPage a::after {
  content: '\\e601';
  font-size: 1.2rem;
  line-height: 3.6rem;
  padding-left: calc(var(--gap) / 4);
}
`;
